import ActionTypes from "./actionTypes";

export const initialState = {
  loading: false,
  userLoggedIn: false,
  authCodeSearch: "",
  userData: {},
  isApiError: false,
  selectedTab: "",
  loadingPer: false,
  selectedAccountingMonth: "",
  selectedReportFilter: 'real time',
  hideDateFilter: false,
  email: "",
  password: "",
  slaReportCountSuccess: {},
  carrierThemeData: {},
  chartDetails: [],
  saleMonthlyTrendData: [],
  salesBusinessData: []
};

const reducer = (state = initialState, action) => {
  switch (action.type) {

    case ActionTypes.SET_LOADING:
      return { ...state, loading: action.payload };

    case ActionTypes.SET_LOADING_DATA:
      return { ...state, loadingData: action.payload };

    case ActionTypes.SET_USER_LOGGED_IN:
      return { ...state, userLoggedIn: action.payload };
    case ActionTypes.SET_AUTH_CODE_SEARCH:
      return { ...state, authCodeSearch: action.payload };
    case ActionTypes.SET_USER_DATA:
      return { ...state, userData: action.payload };

    case ActionTypes.SET_PROGRAM_NAME:
      return { ...state, programName: action.data };

    case ActionTypes.SET_API_ERROR:
      return { ...state, ...{ isApiError: action.data } };

    case ActionTypes.SET_SELECTED_TAB:
      return { ...state, selectedTab: action.payload };


    case ActionTypes.SET_DASHBOARD_LOADING:
      return { ...state, dashboardLoading: action.payload };
    case ActionTypes.SET_PROJECT_NAME:
      return { ...state, projectName: action.payload };

    case ActionTypes.SELECTED_ACCOUNTING_MONTH:
      return { ...state, selectedAccountingMonth: action.payload }

    case ActionTypes.SGP_SET_REPORT_NAME:
      return {
        ...state, selectedStarhubReport: {
          starHubReportName: action.payload?.reportLabel || null,
          starHubReportValue: action.payload?.reportValue || null
        }
      }

    case ActionTypes.SGP_SET_REPORT_FILTER:
      return { ...state, selectedReportFilter: action.payload }

    case ActionTypes.SGP_SET_REPORT_FILTER_DURATION:
      return {
        ...state, reportFilterDuration: {
          type: action.payload.type,
          startDate: action.payload.startDate,
          endDate: action.payload.endDate,
          duration: action.payload.duration
        }
      }

    case ActionTypes.GET_STARHUB_REPORT_COUNT_SUCCESS:
      // console.log('action.payload?.GetReportDetails', action.payload?.GetReportDetails);
      return { ...state, reportCountSuccess: action.payload?.GetReportDetails }

    case ActionTypes.GET_STARHUB_REPORT_COUNT_FAILURE:
      return { ...state, projectDataError: action.payload }

    case ActionTypes.GET_STARHUB_REPORT_COUNT_DETAILS_SUCCESS:
      return { ...state, reportCountDetailsSuccess: action.payload?.GetReportCountDetailsResponse }

    case ActionTypes.GET_STARHUB_REPORT_COUNT_DETAILS_FAILURE:
      return { ...state, projectDataError: action.payload }

    case ActionTypes.GET_STARHUB_REPORT_DETAILS_SUCCESS:
      return { ...state, reportDetailsSuccess: action.payload?.GetReportDetailsResponse }

    case ActionTypes.GET_STARHUB_REPORT_DETAILS_FAILURE:
      return { ...state, projectDataError: action.payload }

    case ActionTypes.HIDE_DATE_FILTER:
      return { ...state, hideDateFilter: action.payload }

    case ActionTypes.SET_USER_DETAILS:
      return { ...state, userDetails: action.payload }

    case ActionTypes.GET_CHART_COUNT_DATA_SUCCESS:
      return { ...state, chartReportCountSuccess: action.payload?.GetAllReportsCount }

    case ActionTypes.GET_CHART_COUNT_DATA_FAILURE:
      return { ...state, projectDataError: action.payload }

    case ActionTypes.SET_EMAIL_ADDRESS:
      return { ...state, email: action.payload }

    case ActionTypes.SET_PASSWORD:
      return { ...state, password: action.payload }
    case ActionTypes.GET_SLA_REPORTS_DETAILS_SUCCESS:
      return { ...state, slaReportCountSuccess: action.payload }

    case ActionTypes.GET_SLA_REPORTS_DETAILS_FAILURE:
      return { ...state, projectDataError: action.payload };
    case ActionTypes.SET_PROJECT_SUB_MENU:
      return { ...state, projectSHSubMenu: action.payload }

    case ActionTypes.SGP_SET_DOWNLOAD_REPORT_DURATION_LABEL:
      return { ...state, selectedDownloadReportDurationLBL: action.payload }

    case ActionTypes.SGP_SET_DOWNLOAD_REPORT_DURATION:
      return { ...state, selectedDownloadReportDuration: action.payload }

    case ActionTypes.SET_THEME_DATA:
      return { ...state, carrierThemeData: action.payload }

    case ActionTypes.SET_CELCOM_CUSTOMER_VALUE_MGMT_DATA:
      return { ...state, chartDetails: action.payload }

    case ActionTypes.SET_HEADER_TITLE:
      return { ...state, headeTitle: action.payload }

    case ActionTypes.SALES_REPORT_MONTHLY_TREND_DATA:
      return { ...state, saleMonthlyTrendData: action.payload }

    case ActionTypes.SALES_REPORT_BUSINESS_DATA:
      return { ...state, salesBusinessData: action.payload }

    default:
      throw new Error();
  }
};

export default reducer;